export default "__VITE_ASSET__10b3254e__"